exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inputW_6ab3ad4{width:230px!important}", ""]);

// exports
exports.locals = {
	"inputW": "inputW_6ab3ad4"
};